import type { Person, PersonAsset, PersonLabel } from "@/entities/person";

const DEMO_TENANT_ID = "1";

export const mockPersons: Person[] = [
  // Führungskräfte (Account Admin)
  {
    id: "per-1",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Sabine",
    lastname: "Hartmann",
    email: "s.hartmann@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234501",
    company: "Bäckerei Rhein-Neckar GmbH",
    address: "Augustaanlage 7, 68165 Mannheim",
    employee_id: "MA-001",
    external: false,
    email_verified: true,
    user_id: "demo-user-1",
    work_role: "TECH_MANAGER",
    system_role: "ACCOUNT_ADMIN",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-2",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Klaus",
    lastname: "Brenner",
    email: "k.brenner@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234502",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-002",
    external: false,
    email_verified: true,
    user_id: "demo-user-2",
    work_role: "TECH_MANAGER",
    system_role: "NORMAL_USER",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Backstube
  {
    id: "per-3",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Petra",
    lastname: "Weiß",
    email: "p.weiss@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234503",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-003",
    external: false,
    work_role: "BRANCH_USER",
    system_role: "NORMAL_USER",
    branch_id: "branch-1",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-4",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Michael",
    lastname: "Krüger",
    email: "m.krueger@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234504",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-004",
    external: false,
    work_role: "BRANCH_USER",
    system_role: "NORMAL_USER",
    branch_id: "branch-2",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-5",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Anna",
    lastname: "Schäfer",
    email: "a.schaefer@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234505",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-005",
    external: false,
    work_role: "BRANCH_USER",
    system_role: "NORMAL_USER",
    branch_id: "branch-3",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Techniker
  {
    id: "per-6",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Thomas",
    lastname: "Müller",
    email: "t.mueller@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234506",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-006",
    external: false,
    email_verified: true,
    user_id: "demo-user-3",
    work_role: "TECHNICIAN",
    system_role: "NORMAL_USER",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-7",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Stefan",
    lastname: "Weber",
    email: "s.weber@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234507",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-007",
    external: false,
    email_verified: true,
    user_id: "demo-user-4",
    work_role: "TECHNICIAN",
    system_role: "NORMAL_USER",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Filialleiter
  {
    id: "per-8",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Lisa",
    lastname: "Hoffmann",
    email: "l.hoffmann@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234508",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-008",
    external: false,
    email_verified: true,
    user_id: "demo-user-5",
    work_role: "BRANCH_USER",
    system_role: "NORMAL_USER",
    branch_id: "branch-1",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-9",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Marco",
    lastname: "Fischer",
    email: "m.fischer@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234509",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-009",
    external: false,
    work_role: "BRANCH_USER",
    system_role: "NORMAL_USER",
    branch_id: "branch-2",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-10",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Julia",
    lastname: "Becker",
    email: "j.becker@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234510",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-010",
    external: false,
    work_role: "BRANCH_USER",
    system_role: "NORMAL_USER",
    branch_id: "branch-3",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Verkaufspersonal
  {
    id: "per-11",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Sandra",
    lastname: "Klein",
    email: "s.klein@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234511",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-011",
    external: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-12",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Nicole",
    lastname: "Richter",
    email: "n.richter@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234512",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-012",
    external: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-13",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Dennis",
    lastname: "Schmitt",
    email: "d.schmitt@baeckerei-rhein-neckar.de",
    phone: "+49 621 1234513",
    company: "Bäckerei Rhein-Neckar GmbH",
    employee_id: "MA-013",
    external: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Externe Service-Techniker
  {
    id: "per-14",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Markus",
    lastname: "Gerätewart",
    email: "m.geraetewart@wiesheu-service.de",
    phone: "+49 7231 9876543",
    company: "Wiesheu Kundendienst",
    external: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-15",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Andreas",
    lastname: "Kältetechnik",
    email: "a.kaelte@liebherr-service.de",
    phone: "+49 7542 876543",
    company: "Liebherr Kältetechnik Service",
    external: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-16",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Bernd",
    lastname: "Kassensystem",
    email: "b.kassensystem@vectron-support.de",
    phone: "+49 251 2856789",
    company: "Vectron Systems Support",
    external: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-17",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Frank",
    lastname: "Spültechnik",
    email: "f.spueltechnik@winterhalter.de",
    phone: "+49 7522 943210",
    company: "Winterhalter Gastronom GmbH",
    external: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "per-18",
    tenant_id: DEMO_TENANT_ID,
    firstname: "Carsten",
    lastname: "Dampfservice",
    email: "c.dampf@rational-service.de",
    phone: "+49 8191 327654",
    company: "Rational AG Kundendienst",
    external: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const mockPersonLabels: PersonLabel[] = [
  {
    id: "plbl-1",
    person_id: "per-1",
    label_id: "lbl-1",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "plbl-2",
    person_id: "per-2",
    label_id: "lbl-2",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "plbl-3",
    person_id: "per-3",
    label_id: "lbl-3",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "plbl-4",
    person_id: "per-6",
    label_id: "lbl-7",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "plbl-5",
    person_id: "per-7",
    label_id: "lbl-7",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "plbl-6",
    person_id: "per-14",
    label_id: "lbl-1",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "plbl-7",
    person_id: "per-15",
    label_id: "lbl-4",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const mockPersonAssets: PersonAsset[] = [
  // Thomas Müller (Techniker) - verantwortlich für Backöfen
  {
    id: "pa-1",
    person_id: "per-6",
    asset_id: "asset-1",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "pa-2",
    person_id: "per-6",
    asset_id: "asset-2",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "pa-3",
    person_id: "per-6",
    asset_id: "asset-3",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Stefan Weber (Techniker) - verantwortlich für Kühlgeräte
  {
    id: "pa-4",
    person_id: "per-7",
    asset_id: "asset-5",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "pa-5",
    person_id: "per-7",
    asset_id: "asset-9",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Externe: Wiesheu-Techniker
  {
    id: "pa-6",
    person_id: "per-14",
    asset_id: "asset-1",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "pa-7",
    person_id: "per-14",
    asset_id: "asset-2",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Externe: Liebherr-Techniker
  {
    id: "pa-8",
    person_id: "per-15",
    asset_id: "asset-5",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "pa-9",
    person_id: "per-15",
    asset_id: "asset-9",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Externe: Rational-Techniker
  {
    id: "pa-10",
    person_id: "per-18",
    asset_id: "asset-4",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
